var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31.5,
    r: 30.5,
    fill: "#F47920",
    stroke: "#F47920"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 23.5V36.5C40.0001 36.7652 39.8947 37.0196 39.7072 37.2071C39.5196 37.3946 39.2653 37.5 39.0001 37.5C38.7349 37.5 38.4805 37.3946 38.293 37.2071C38.1054 37.0196 38.0001 36.7652 38.0001 36.5V25.9137L23.7076 40.2075C23.5199 40.3951 23.2654 40.5006 23.0001 40.5006C22.7347 40.5006 22.4802 40.3951 22.2926 40.2075C22.1049 40.0199 21.9995 39.7654 21.9995 39.5C21.9995 39.2346 22.1049 38.9801 22.2926 38.7925L36.5863 24.5H26.0001C25.7349 24.5 25.4805 24.3946 25.293 24.2071C25.1054 24.0196 25.0001 23.7652 25.0001 23.5C25.0001 23.2348 25.1054 22.9804 25.293 22.7929C25.4805 22.6054 25.7349 22.5 26.0001 22.5H39.0001C39.2653 22.5 39.5196 22.6054 39.7072 22.7929C39.8947 22.9804 40.0001 23.2348 40.0001 23.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrowUpRight.7edc6911df1407f2b32cad31e33ca256.svg";
export { ForwardRef as ReactComponent };